import { Stack, Typography } from "@mui/material";
import { RewardCalculationTypeEditorProps } from "../../../../types/actionModule/editor/rewardCalculationTypeEditorTypes";
import { useTranslation } from "react-i18next";

export default function ManualInputRewardCalculationTypeEditor(props: RewardCalculationTypeEditorProps) {
    const { t } = useTranslation();

    return <Stack>
        <Typography variant="caption">{t("actionModules.rewardCalculationType.manualInput.description")}</Typography>
    </Stack>
}